(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ReasonCodeDialogController', ReasonCodeDialogController);

    ReasonCodeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ReasonCode'];

    function ReasonCodeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ReasonCode) {
        var vm = this;

        vm.reasonCode = entity;

        vm.notificationQuestioinnaireTypes = ["ANOMALY",
            "CLOSE_CALL","DANGER","PROPOSITION",
            "CHANGE_NOTIFICATION", "BULLETIN_NOTIFICATION", "INJURY_NOTIFICATION", "RECLAMATION_NOTIFICATION"];
        vm.newQuestionnaireType = null;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.reasonCode.id !== null) {
                ReasonCode.update(vm.reasonCode, onSaveSuccess, onSaveError);
            } else {
                ReasonCode.save(vm.reasonCode, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:reasonCodeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.addQuestionnaireType = function(){
            if (vm.reasonCode.questionnaireTypes.indexOf(vm.newQuestionnaireType) >= 0){
                vm.newQuestionnaireType = null;
                return;
            }
            vm.reasonCode.questionnaireTypes.push(vm.newQuestionnaireType);
            vm.newQuestionnaireType = null;
        };

        vm.removeQuestionnaireType = function(type){
            var index = vm.reasonCode.questionnaireTypes.indexOf(type);
            if (index >= 0){
                vm.reasonCode.questionnaireTypes.splice(index, 1)
            }
        };


    }
})();
